import { render } from "./BalanceActivityTable.vue?vue&type=template&id=6f836daa&scoped=true"
import script from "./BalanceActivityTable.vue?vue&type=script&lang=js"
export * from "./BalanceActivityTable.vue?vue&type=script&lang=js"

import "./BalanceActivityTable.vue?vue&type=style&index=0&id=6f836daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f836daa"]])

export default __exports__